import React, { Component } from 'react';
import shallowEqual from 'shallowequal';
import { connectAdvanced } from 'react-redux';
import * as actions from './testStationActions';
import Station from './components/Station';
import StationSwitcher from './components/StationSwitcher';
import FirmwareUpdate from './components/FirmwareUpdate';
import ApkUpdate from './components/ApkUpdate';
import './TestStation.css';
import Loader from '../loader/Loader';
import DebounceButton from './components/DebounceButton';
import { delayAction, isEmployee, isFranchisee } from '../utils';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import { stationModels } from '../constants/stationModels';

class TestStation extends Component {
    onSelect = sno => {
        this.props.action.startLoading();
        delayAction(() => {
            this.props.action.choice(sno);
            this.props.history.replace({
                search: `?sno=${sno}`,
            });
        }, 1500);
    };

    refresh = () => {
        this.props.action.startLoading();
        delayAction(() => {
            this.props.action.loadSnoList({
                offset: 0,
                limit: actions.STATIONS_PAGE_LIMIT,
                append: false,
            });
            this.props.action.loadSlotsList();
        }, 1500);
    };

    restart = station => {
        if (!station) return false;

        if (window.confirm('Вы уверены, что хотите перезагрузить устройство?')) {
            this.props.action.restart(station.sno);
            return true;
        }

        return false;
    };

    componentDidMount() {
        // this.timer = setInterval(this._tick, 6000);
        // this.timerSlow = setInterval(this._tickSlow, 600000);
        const snoParam = new URLSearchParams(this.props.location.search).get('sno');
        const selectedSno = snoParam || this.props.state.active;

        this.props.action.loadSnoList({
            offset: 0,
            limit: actions.STATIONS_PAGE_LIMIT,
            append: false,
            ...(selectedSno
                ? {
                      searchField: 'sno',
                      searchQuery: selectedSno,
                      rawSearchQuery: selectedSno,
                  }
                : {}),
        });

        snoParam && this.onSelect(snoParam);
        // this.props.action.connect();
    }

    componentWillUnmount() {
        // clearInterval(this.timer);
        // clearInterval(this.timerSlow);
        // this.props.action.disconnect();
    }

    render() {
        const {
            snoList,
            snoTotal,
            snoUnfilteredTotal,
            snoLimit,
            slotsList,
            logsList,
            active,
            activeStation,
            isLoading,
            isSnoListLoading,
        } = this.props.state;
        const {
            loadSnoList,
            loadMoreSnoList,
            extract,
            open,
            updateAdminStatus,
            updateConflictStatus,
            changeAllStatuses,
            canAccessFirmware,
            getFirmwareVersion,
            loadFirmwareFiles,
            updateFirmware,
            getApkVersion,
            loadApkFiles,
            updateApk,
        } = this.props.action;
        const permissions = localStorage.getItem('permissions');
        const station = activeStation || snoList.find(x => x.sno === active);

        return (
            <div style={{ position: 'relative' }}>
                {isLoading && (
                    <div className="loader-container">
                        <Loader />
                    </div>
                )}
                <div className={'wrapper'}>
                    <div className="testStation-row">
                        <div className="testStation-row-block testStation-switcher-block">
                            <StationSwitcher
                                snoList={snoList}
                                choice={this.onSelect}
                                active={active}
                                activeStation={activeStation}
                                total={snoTotal}
                                displayTotal={snoUnfilteredTotal}
                                loadedTo={this.props.state.snoNextOffset}
                                limit={snoLimit}
                                loadStations={loadSnoList}
                                loadMore={loadMoreSnoList}
                                isLoading={isSnoListLoading}
                                showPosAppInfo={
                                    isEmployee(permissions) || isFranchisee(permissions)
                                }
                            />
                        </div>
                        <div className="testStation-updates-row">
                            <FirmwareUpdate
                                station={station}
                                permissions={permissions}
                                canAccessFirmware={canAccessFirmware}
                                getFirmwareVersion={getFirmwareVersion}
                                loadFirmwareFiles={loadFirmwareFiles}
                                updateFirmware={updateFirmware}
                            />
                            <ApkUpdate
                                station={station}
                                permissions={permissions}
                                canAccessFirmware={canAccessFirmware}
                                getApkVersion={getApkVersion}
                                loadApkFiles={loadApkFiles}
                                updateApk={updateApk}
                            />
                        </div>
                        <div className="testStation-buttons-row">
                            <div
                                className="testStation-row-block testStation-restart-block"
                                style={{
                                    display:
                                        station && station.model === stationModels.relink_station
                                            ? 'flex'
                                            : 'none',
                                }}
                            >
                                <div className="station-control-label">Перезагрузка</div>
                                <DebounceButton
                                    className="restartButton"
                                    icon={<PowerSettingsNewIcon />}
                                    onRefresh={() => this.restart(station)}
                                />
                            </div>
                            <div className="testStation-row-block testStation-refresh-block">
                                <div className="station-control-label">Обновить</div>
                                <DebounceButton onRefresh={this.refresh} />
                            </div>
                        </div>
                    </div>
                    <Station
                        active={active}
                        activeStation={activeStation}
                        open={open}
                        snoList={snoList}
                        slotsList={slotsList}
                        logsList={logsList}
                        extract={extract}
                        updateAdminStatus={updateAdminStatus}
                        updateConflictStatus={updateConflictStatus}
                        changeAllStatuses={changeAllStatuses}
                    />
                </div>
            </div>
        );
    }
}

function selectorFactory(dispatch) {
    let result = {};
    return (nextState, nextOwnProps) => {
        const state = {
            ...nextState.test,
            isLoading: nextState.test.isLoading,
        };
        const defaultSnoSearchParams = state.snoSearch || {};
        const action = {
            startLoading: () => actions.startLoading(dispatch),
            loadSlotsList: () => actions.loadSlotsList(dispatch, state.active),
            loadSnoList: params =>
                actions.loadSnoList(dispatch, {
                    ...defaultSnoSearchParams,
                    ...(params || {}),
                }),
            loadMoreSnoList: params => {
                const offset =
                    params && typeof params.offset === 'number'
                        ? params.offset
                        : state.snoNextOffset;
                const limit = params && params.limit ? params.limit : state.snoLimit;

                if (state.isSnoListLoading || (state.snoTotal && offset >= state.snoTotal)) {
                    return Promise.resolve();
                }

                return actions.loadSnoList(dispatch, {
                    ...defaultSnoSearchParams,
                    offset,
                    limit,
                    append: true,
                });
            },
            choice: val => actions.choice(dispatch, val, state.socket),
            extract: params => actions.extract(dispatch, params, state),
            loadLogsList: () => actions.loadLogsList(dispatch, state.active, state.datetime),
            connect: () => actions.connect(dispatch, state.active),
            disconnect: () => actions.disconnect(dispatch, state.socket),
            open: params => actions.open(dispatch, params, state),
            updateAdminStatus: params => actions.updateAdminStatus(dispatch, params, state),
            updateConflictStatus: params => actions.updateConflictStatus(dispatch, params, state),
            changeAllStatuses: params => actions.changeAllStatuses(dispatch, params, state),
            restart: params => actions.restart(dispatch, params),
            canAccessFirmware: sno => actions.canAccessFirmware(dispatch, sno),
            getFirmwareVersion: sno => actions.getFirmwareVersion(dispatch, sno),
            loadFirmwareFiles: () => actions.loadFirmwareFiles(dispatch),
            updateFirmware: (sno, fileId) => actions.updateFirmware(dispatch, sno, fileId),
            getApkVersion: sno => actions.getApkVersion(dispatch, sno),
            loadApkFiles: () => actions.loadApkFiles(dispatch),
            updateApk: (sno, fileId) => actions.updateApk(dispatch, sno, fileId),
        };
        const nextResult = { ...nextOwnProps, state, action };
        if (!shallowEqual(result, nextResult)) result = nextResult;
        return result;
    };
}
export default connectAdvanced(selectorFactory)(TestStation);
